import './LegalPage.css';

function PrivacyPage() {
    return (
        <div className="Legal-content">
            <div className="glass-card legal-card">
                <h1 className="legal-title">Privacy Policy</h1>
                
                <div className="legal-text">
                    <p className="last-updated">Effective Date: July 25, 2025</p>
                    
                    <p>Geomatchry ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our dating application (the "App").</p>
                    
                    <h2>1. Information We Collect</h2>
                    
                    <h3>1.1 Information You Provide</h3>
                    <p>When you use Geomatchry, you directly provide us with:</p>
                    <ul>
                        <li><strong>Account Information:</strong> Email address and age verification</li>
                        <li><strong>Profile Information:</strong> Name, profile photo, bio, school, and job</li>
                        <li><strong>Content:</strong> Messages you send to matched users and Live Marker photos you take</li>
                        <li><strong>Reports:</strong> Information you provide when reporting users</li>
                    </ul>
                    
                    <h3>1.2 Information Collected Automatically</h3>
                    <p>When you use our App, we automatically collect:</p>
                    <ul>
                        <li><strong>Location Data:</strong> Your device's location when you place markers (required for core functionality)</li>
                        <li><strong>Device Information:</strong> Device model, operating system, unique device identifiers, language settings, time zone</li>
                        <li><strong>Usage Data:</strong> How you interact with the App, features you use, and actions you take</li>
                        <li><strong>Technical Data:</strong> IP address, crash reports, performance data, app version</li>
                        <li><strong>Analytics Data:</strong> Events and interactions tracked through Firebase Analytics</li>
                    </ul>
                    
                    <h3>1.3 Information We Don't Collect</h3>
                    <p>We do not collect or store:</p>
                    <ul>
                        <li>Your exact location data beyond the moment of marker placement</li>
                        <li>Financial information (the App is free)</li>
                        <li>Health or biometric data</li>
                        <li>Precise demographic information beyond age verification</li>
                    </ul>
                    
                    <h2>2. How We Use Your Information</h2>
                    <p>We use your information to:</p>
                    <ul>
                        <li><strong>Provide Core Services:</strong> Enable marker placement and user discovery</li>
                        <li><strong>Facilitate Connections:</strong> Allow matched users to message each other</li>
                        <li><strong>Ensure Safety:</strong> Review reports, moderate content, and enforce our Terms of Service</li>
                        <li><strong>Improve the App:</strong> Analyze usage patterns and fix technical issues</li>
                        <li><strong>Communicate:</strong> Send service-related notifications</li>
                        <li><strong>Legal Compliance:</strong> Respond to legal requests and prevent harm</li>
                    </ul>
                    
                    <h2>3. How We Share Your Information</h2>
                    
                    <h3>3.1 With Other Users</h3>
                    <ul>
                        <li>Your profile (name, photo, bio, school, job) is visible to users who place markers within your selected parameters</li>
                        <li>Live Marker photos are shown to users viewing that marker</li>
                        <li>Your exact location is never shared - users only know you're within their search parameters</li>
                        <li>Messages are only visible to matched users</li>
                    </ul>
                    
                    <h3>3.2 With Service Providers</h3>
                    <p>We use Google Firebase for:</p>
                    <ul>
                        <li>Backend infrastructure and data storage</li>
                        <li>Analytics</li>
                        <li>Push notifications</li>
                    </ul>
                    <p>Firebase processes data according to our instructions and their privacy policies.</p>
                    
                    <h3>3.3 Other Disclosures</h3>
                    <p>We may disclose your information:</p>
                    <ul>
                        <li>To comply with legal obligations</li>
                        <li>To protect rights, safety, or property</li>
                        <li>In connection with a sale or merger of our business</li>
                        <li>With your consent</li>
                    </ul>
                    <p><strong>We do not sell your personal information to third parties.</strong></p>
                    
                    <h2>4. Data Storage and Security</h2>
                    
                    <h3>4.1 Storage</h3>
                    <p>Your data is stored on Google Firebase servers in the United States. By using Geomatchry, you consent to the transfer and storage of your information in the United States.</p>
                    
                    <h3>4.2 Security</h3>
                    <p>We implement technical and organizational measures to protect your information. However, no method of transmission or storage is 100% secure. While we strive to protect your data, we cannot guarantee absolute security.</p>
                    
                    <h3>4.3 Message Security</h3>
                    <p>Messages between users are not end-to-end encrypted and may be accessed by us for safety and moderation purposes.</p>
                    
                    <h2>5. Your Rights and Choices</h2>
                    
                    <h3>5.1 Access and Portability</h3>
                    <p>You can:</p>
                    <ul>
                        <li>View your profile information in the App</li>
                        <li>Request a copy of your data by emailing <a href="mailto:support@geomatchry.com">support@geomatchry.com</a></li>
                    </ul>
                    
                    <h3>5.2 Deletion</h3>
                    <p>You can delete your account at any time through App settings. Upon deletion:</p>
                    <ul>
                        <li>Your profile, messages, markers, and photos are immediately removed</li>
                        <li>Reports you've submitted remain for safety purposes</li>
                        <li>If you delete your account while under investigation, your messages will be deleted, which may affect our review</li>
                    </ul>
                    
                    <h3>5.3 Location Services</h3>
                    <p>You can control location permissions through your device settings, though this will limit App functionality.</p>
                    
                    <h3>5.4 Communications</h3>
                    <p>You can manage push notification preferences through your device settings.</p>
                    
                    <h2>6. Data Retention</h2>
                    <p>We retain your information while your account is active. Upon account deletion, we immediately delete your data except:</p>
                    <ul>
                        <li>Reports submitted about policy violations (retained for safety)</li>
                        <li>Information we must keep for legal compliance</li>
                    </ul>
                    
                    <h2>7. Children's Privacy</h2>
                    <p>Geomatchry is not intended for users under 18. We do not knowingly collect information from children under 18. If we learn we've collected information from a child under 18, we will promptly delete it.</p>
                    
                    <h2>8. California Privacy Rights</h2>
                    <p>If you're a California resident, you have additional rights under the California Consumer Privacy Act (CCPA):</p>
                    <ul>
                        <li>Right to know what personal information we collect</li>
                        <li>Right to delete your personal information</li>
                        <li>Right to opt-out of the sale of personal information (we don't sell your data)</li>
                        <li>Right to non-discrimination for exercising privacy rights</li>
                    </ul>
                    <p>To exercise these rights, contact us at <a href="mailto:support@geomatchry.com">support@geomatchry.com</a>.</p>
                    
                    <h2>9. International Users</h2>
                    <p>Geomatchry is currently only available in the United States. We do not intentionally collect information from users outside the United States.</p>
                    
                    <h2>10. Changes to This Policy</h2>
                    <p>We may update this Privacy Policy from time to time. We will notify you of material changes through the App or via email. Your continued use after changes constitutes acceptance of the updated policy.</p>
                    
                    <h2>11. Contact Us</h2>
                    <p>If you have questions about this Privacy Policy or our privacy practices, please email us at: <a href="mailto:support@geomatchry.com">support@geomatchry.com</a>.</p>
                    
                    <p className="last-updated">Last Updated: July 25, 2025</p>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPage;